export enum FEATURE_FLAGS {
  IS_LIFE_SUMMARY_ENABLED = "is_life_summary_enabled",
  IS_TIMELINE_ENABLED = "is_timeline_enabled",
}
